module.exports = __webpack_public_path__ + "static/media/faqs.bc3e4679.svg";